var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', {
    staticClass: "logoutContainer"
  }, [_c('v-card', {
    staticClass: "pr-12 pl-12 pt-7 pb-7 mt-n9",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_c('h3', {
    staticClass: "bold"
  }, [_vm._v(" Berechtigungen ")])]), _c('v-card-text', [[_c('v-simple-table', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn() {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left"
        }, [_vm._v(" Permission ")]), _c('th', {
          staticClass: "text-left"
        }, [_vm._v(" Action ")]), _c('th', {
          staticClass: "text-left"
        }, [_vm._v(" Subject ")])])]), _c('tbody', _vm._l(_vm.permissions, function (perm) {
          return _c('tr', {
            key: perm.name
          }, [perm.inverted ? _c('td', [_vm._v("cannot")]) : _c('td', [_vm._v("can")]), _c('td', [_vm._v(_vm._s(perm.action))]), _c('td', [_vm._v(_vm._s(perm.subject))])]);
        }), 0)];
      },
      proxy: true
    }])
  })]], 2)], 1), _c('v-card', {
    staticClass: "mt-8 pr-12 pl-12 pt-7 pb-7",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_c('h3', {
    staticClass: "bold"
  }, [_vm._v(" Rollen ")])]), _c('v-card-text', [[_c('v-simple-table', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn() {
        return [_c('tbody', _vm._l(_vm.user.roles, function (role) {
          return _c('tr', {
            key: role
          }, [_c('td', {
            staticStyle: {
              "border": "none"
            }
          }, [_vm._v(_vm._s(role))])]);
        }), 0)];
      },
      proxy: true
    }])
  })]], 2)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }